import _extends from "@babel/runtime/helpers/extends";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from '../Modal';
var OffCanvasModal = styled(Modal).withConfig({
  displayName: "OffCanvasMenu__OffCanvasModal",
  componentId: "sc-17m4nk2-0"
})(["\n  .Overlay {\n    justify-content: ", ";\n    transition: all ", "ms ease-out;\n\n    &.ReactModal__Overlay--after-open {\n      background: rgba(0, 0, 0, 0.6);\n    }\n\n    &,\n    &.ReactModal__Overlay--before-close {\n      background: transparent;\n    }\n  }\n\n  .Modal {\n    width: auto;\n    max-width: 100vw;\n    height: 100vh;\n    transition: all ", "ms ease;\n\n    &.ReactModal__Content--after-open {\n      transform: translate3d(0, 0, 0);\n    }\n\n    &,\n    &.ReactModal__Content--before-close {\n      transform: translate3d(", "100%, 0, 0);\n    }\n  }\n"], function (props) {
  return props.right ? 'flex-end' : 'flex-start';
}, function (props) {
  return props.closeTimeoutMS;
}, function (props) {
  return props.closeTimeoutMS;
}, function (props) {
  return props.right ? '' : '-';
});
/**
 * A modal menu that slides in from the left or the right. The menu is actually
 * a restyled `Modal` component, so all of the same props from [react-modal](https://reactcommunity.org/react-modal/)
 * apply.
 *
 * Like `Modal`, the `OffCanvasMenu` does not have any default width. You should
 * wrap your content in a container that has the width you want, and the menu
 * will automatically adapt.
 */

var OffCanvasMenu =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(OffCanvasMenu, _React$Component);

  function OffCanvasMenu() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = OffCanvasMenu.prototype;

  _proto.render = function render() {
    var transitionDuration = this.props.transitionDuration;
    return React.createElement(OffCanvasModal, _extends({}, this.props, {
      closeTimeoutMS: transitionDuration
    }));
  };

  return OffCanvasMenu;
}(React.Component);

_defineProperty(OffCanvasMenu, "propTypes", {
  /**
   * Whether to slide in from the right side of the viewport.
   */
  right: PropTypes.bool,

  /**
   * The number of milliseconds the animation takes. This will be passed along
   * to the underlying `Modal` as the `closeTimeoutMS` prop.
   */
  transitionDuration: PropTypes.number,

  /**
   * The content to render inside the menu.
   */
  children: PropTypes.node
});

_defineProperty(OffCanvasMenu, "defaultProps", {
  right: false,
  transitionDuration: 300
});

export { OffCanvasMenu as default };